
export const signals = [
    { "id": "0", "value": "None" },
    { "id": "1", "value": "Mô hình nến" },
    { "id": "2", "value": "Khối lượng" },
    { "id": "3", "value": "Chỉ báo kỹ thuật" }
]